const reducerPedidoTypes = {
    SET_PEDIDO: "setPedido",
    GET_PEDIDO: "getPedido",
}

const reducerPedido = (state = {pedido: {itens:[]}, reducerPedidoTypes: reducerPedidoTypes}, {type, payload}) => {
switch(type){
        case 'setPedido':
            return Object.assign({}, state, {pedido:payload});
        case 'getPedido':
            return {
                ...state
            }
        default:
            return state;
    }
};



/* const defaultState = {pedido: {itens:[]}}; */
//export default {reducerPedido, defaultState, reducerPedidoTypes};
export default reducerPedido;